<div [formGroup]="element?.group">
  <div [ngClass]="element?.theme?.outerWrap">
    @if (element?.elementOptions?.label) {
      <label [ngClass]="element?.theme?.labelClass"
        >{{ element?.elementOptions?.label }}
        @if (element.validations?.required) {
          <b
          style="color:red">*</b>
        }
        @if (element?.tooltip?.display) {
          <span>
            <i class="fa fa-question-circle"
              aria-hidden="true"
              placement="{{element?.tooltip?.placement || 'right' }}"
            ngbTooltip="{{element.tooltip.text}}"></i>
          </span>
        } : </label>
      }
      <!-- Check all check box to check all the checkboxes -->
      @if (element.elementOptions.checkAll) {
        <div [ngClass]="element?.theme?.alignmentClass"
          >
          <input type="checkbox"
            [attr.name]="element?.elementOptions.name"
            [attr.value]="element?.elementOptions.value"
            [ngClass]="element?.theme?.control"
            [checked]="isAllCheckBoxesChecked()"
            (change)="checkAllCheckBoxes($event);" />
            <label [ngClass]="element?.theme?.childLabel"
              [attr.for]="element?.elementOptions.id">
            {{ element?.elementOptions.checkAllLabel }}</label>
          </div>
        }
        <!-- These checkboxes will be rendered dependes on the elements present in the checkBoxOptionsArray -->
        @for (option of checkBoxOptionsArray; track option) {
          <div [ngClass]="element?.theme?.alignmentClass">
            <input type="checkbox"
              [attr.name]="element.elementOptions.name"
              [attr.value]="option.value"
              [ngClass]="element?.theme?.control"
              [checked]="option.checked"
              [disabled]="option.disabled"
              (change)="onCheckBoxClickTrigged($event)">
              <label [ngClass]="element?.theme?.childLabel">{{ option.label || option.value }} </label>
            </div>
          }
          @if (element.group.controls[this.element['name']]?.dirty && !element?.group?.controls[this.element['name']]?.pristine && element?.group?.controls[this.element['name']]?.errors) {
            <div class="alert alert-danger"
              role="alert"
              style="width:100%"
              >
              <rs-error-message [fieldForm]="element?.group?.controls[this.element['name']]"
              [field]="element"></rs-error-message>
            </div>
          }
        </div>

      </div>
